export default [
  {
    path: '/pages/activity/wulin/index',
    name: 'wulin',
    component: () => import('@/pages/activity/wulin/index.vue'),
    meta: {
      title: '小郭的心愿清单-武林外传：十年之约',
      keepAlive: true
    }
  },
  {
    path: '/pages/activity/wulinteam/index',
    name: 'wulinteam',
    component: () => import('@/pages/activity/wulinteam/index.vue'),
    meta: {
      title: '武林组队活动',
      keepAlive: true
    }
  },
  {
    path: '/pages/activity/newteam/index',
    name: 'newteam',
    component: () => import('@/pages/activity/newteam/index.vue'),
    meta: {
      title: '新组队活动',
      keepAlive: true
    }
  },
  {
    path: '/pages/activity/drinkingParty/index',
    name: 'drinkingParty',
    component: () => import('@/pages/activity/drinkingParty/index.vue'),
    meta: {
      title: '江湖酒局活动',
      keepAlive: true
    }
  },
  {
    path: '/pages/activity/template/index',
    name: 'template',
    component: () => import('@/pages/activity/template/index.vue'),
    meta: {
      title: '活动',
      keepAlive: true
    }
  },
  {
    path: '/pages/activity/drinkingParty/copy/index',
    name: 'drinkingParty1',
    component: () => import('@/pages/activity/drinkingParty/copy/index.vue'),
    meta: {
      title: '江湖酒局活动',
      keepAlive: true
    }
  },
  {
    path: '/pages/activity/flyParty/index',
    name: 'flyParty',
    component: () => import('@/pages/activity/flyParty/index.vue'),
    meta: {
      title: '飞飞活动',
      keepAlive: true
    }
  },
  {
    path: '/pages/activity/shenqi/index',
    name: 'shenqi',
    component: () => import('@/pages/activity/shenqi/index.vue'),
    meta: {
      title: '神泣活动',
      keepAlive: true
    }
  },
  {
    path: '/pages/activity/hallFame/index',
    name: 'hallFame',
    component: () => import('@/pages/activity/hallFame/index.vue'),
    meta: {
      title: '名人堂',
      keepAlive: true
    }
  },
]
